import { DotWave } from '@uiball/loaders'


export default function CommonDotWave ({size}) {
    return (
        <DotWave size={size} speed={1} color="#D9534F" />
    )
}